<template>
  <!-- eslint-disable -->
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title>
        </v-card-title>
        <v-card-text>
          <div v-if="!apiconnection" class="text-xs-center">
            <p>Connecting</p>
            <div style="text-align: center;">
              <v-progress-circular v-if="apiconnection==null" style="align:center" indeterminate color="primary"></v-progress-circular>
            </div>
          </div>
          <div v-else>
            {{apiconnection.message}}
            <div v-if="apiconnection.services">Select a default service:</div>
            <v-list>
              <v-list-item avatar class="default-service-item" v-for="item in apiconnection.services" :key="item.title" @click="setDefaultService(item.ServiceName)">
                <v-list-item-content>
                  <v-list-item-title v-text="item.ServiceName"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="service-modal-close-btn" text @click.stop="clearApiConnection()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
<!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import { EVENTS } from "./config";
import { COURIER_CONFIG_NAMESPACE } from "./store/courierConfigStore";
export default {
  name: "ApiService",
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapGetters("courierConfigModule", ["apiconnection"])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on(EVENTS.OPEN_SERVICE_DIALOG, this.load);
  },
  methods: {
    load(courierItem) {
      this.courierModel = courierItem;
      return this.getServices();
    },
    setDefaultService(serviceName) {
      this.$parent.$emit(EVENTS.SET_DEFAULT_API_SERVICE, serviceName);
      this.clearApiConnection();
    },
    clearApiConnection() {
      this.dialog = false;
      this.$store.dispatch(`${COURIER_CONFIG_NAMESPACE}/clearApiConnection`);
    },
    getServices() {
      this.dialog = true;
      return this.$store.dispatch(`${COURIER_CONFIG_NAMESPACE}/getServices`, {
        user: this.courierModel.ApiUserName,
        pass: this.courierModel.ApiPassword,
        endpoint: this.courierModel.ApiEndpoint
      });
    }
  }
};
</script>
